import { render, staticRenderFns } from "./LightBoxVideo.vue?vue&type=template&id=b3fe928e&"
import script from "./LightBoxVideo.vue?vue&type=script&lang=js&"
export * from "./LightBoxVideo.vue?vue&type=script&lang=js&"
import style0 from "./LightBoxVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports